// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h4[data-v-79f84660]{font-weight:bold}.danger-zone__dialog[data-v-79f84660] .modal-container{padding-block:4px 8px;padding-inline:12px 8px}`, "",{"version":3,"sources":["webpack://./src/components/ConversationSettings/DangerZone.vue"],"names":[],"mappings":"AACA,oBACC,gBAAA,CAKC,uDACC,qBAAA,CACA,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
